import { render, staticRenderFns } from "./groupPollComments.vue?vue&type=template&id=579d4e15&"
import script from "./groupPollComments.vue?vue&type=script&lang=js&"
export * from "./groupPollComments.vue?vue&type=script&lang=js&"
import style0 from "./groupPollComments.vue?vue&type=style&index=0&id=579d4e15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports